(function() {
    module.exports = {
        init: init,
        start: start,
        stop: stop,
        test: test,
    }

    function test() {
        console.log("test")
    }

    var scratchPad;
    var output;
    var ctx;
    var data = [];
    var heatmap;
    var mexicoOutline;
    var drawing = false;

    function init() {
        console.log("heatmap init")
        scratchPad = document.getElementById('scratch-pad');
        output = document.getElementById('heatmap');
        ctx = output.getContext('2d');
        heatmap = simpleheat(scratchPad);
        heatmap.radius(radius,rBlur);
        var i = 0;
        while (i<10) {
            data.push([Math.floor((Math.random() *750)+375), Math.floor((Math.random() *600)+200), 1]);
            i = i+1;
        }
        mexicoOutline = document.getElementById("mexico-outline");
        draw()
    }

    function start() {
        if(drawing == false) {
            drawing = true;
            draw();
        };
    }

    function stop() {
        drawing = false;
        data = [];
    }

    window.requestAnimFrame = (function(){
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function(callback, element){
                window.setTimeout(callback, 1000 / 60);
            };
    })();

    var gradient = {0:'rgb(51,0,79)', 0.2:'rgb(80,0,117)', 0.4:'rgb(7,22,158)', 0.6:'rgb(69,96,217)', 0.8:'rgb(93,173,255)', 1:'white'};

    var speed = 5;
    var decline = 0.001;

//    var scratchPad = document.getElementById('scratch-pad');
//    var output = document.getElementById('heatmap');
//    var ctx = output.getContext('2d');

//    var heatmap = simpleheat(scratchPad);
    var radius = 17;
    var rBlur = 40;
    //    heatmap.gradient(gradient);
//    heatmap.radius(radius,rBlur);
  //  var data = [];

 /*   var i = 0;
    while (i<10) {
        data.push([Math.floor((Math.random() *750)+375), Math.floor((Math.random() *600)+200), 1]);
        i = i+1;
    }*/

    function addPoints(){
        line = Math.floor((Math.random() * data.length));
        xStep = Math.floor((Math.random() * 100)-50);
        yStep = Math.floor((Math.random() * 100)-50);
        valStep = 0.1;
        data.push([data[line][0] + xStep, data[line][1] + yStep, data[line][2] + valStep]);
    };

    function addNew() {
        x = Math.floor((Math.random() * 750)+375);
        y = Math.floor((Math.random() * 400)+200);
        data.push([x,y,1]);
    }

    function step() {
        //for (point in data) {
        //    data[point][2] = data[point][2] - decline;
        //    if (data[point][2] == 0) {
        //data.splice(point, 1);
        //    };
        //}
        i = 0;
        while(i<speed) {
            addPoints();
            i = i +1;
        }

    }

//    var mexicoOutline = document.getElementById("mexico-outline");

    function draw() {
        heatmap.clear();
        heatmap.data(data);
        heatmap.draw();
        ctx.globalCompositeOperation = 'source-over';
        ctx.drawImage(mexicoOutline, 130, 0);
        ctx.globalCompositeOperation = 'source-in';
        ctx.drawImage(scratchPad, 0, 0);
        ctx.globalCompositeOperation = 'destination-over';
        ctx.drawImage(mexicoOutline, 130, 0);
        requestAnimFrame(function () {
            if(drawing==true) {
                step();
                draw();
            };
        });
    };
})();